import { makeStyles, Theme } from "@material-ui/core/styles";
import { CollectibleType, CollectibleProps } from "../../../models/collectible";

const getBackground = (type: CollectibleType) => {
  if (type === "Podcast") return "#17295B";
  if (type === "Book") return "#024599";
  if (type === "Article" || type === "Other" || type === "Calculator")
    return "#235693";

  return "#4187B6";
};

export const CollectibleStyles = makeStyles<Theme, CollectibleProps>(
  (theme) => ({
    root: {
      "&:hover": {
        cursor: "pointer",
      },
    },
    container: ({ collectableType }) => ({
      borderRadius: 8,
      display: "flex",
      background: getBackground(collectableType),
      paddingInline: 18.5,
      paddingBlock: 28,
      height: 420,
    }),
    typeLabel: {
      fontFamily: "Lato",
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(16),
      color: "#FFF",
      marginInlineStart: 7,
    },
    title: {
      fontFamily: "Lato",
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(22),
      color: "#FFF",
      lineHeight: "30.8px",
      marginBlock: "5px 10px",
      flexBasis: 170,
      cursor: "pointer",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    divider: {
      backgroundColor: "#FFF",
    },
    icon: {
      "& path": {
        fill: "#FFF",
      },
    },
    avatar: {
      width: 60,
      height: 60,
      "& svg": {
        width: "100%",
        height: "100%",
      },
    },
    postedBy: {
      fontFamily: "Lato",
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(14),
      color: "#FFF",
    },
    name: {
      fontFamily: "Lato",
      fontWeight: 600,
      fontSize: theme.typography.pxToRem(16),
      color: "#FFF",
    },
    button: {
      margin: "20px 0",
    },
  })
);
